import React, { Component } from 'react';
import './_styles.scss';
import { Button } from 'packages/components';

export default class LandingIconButton extends Component {
   constructor(props) {
    super(props);
  }

  render() {
    const { icon, onClick, className = '', onErrorLoadAsset = () => {} } = this.props;

    return (
      <Button
        className={`landing-telmex__secondary-telmex focusable ${className}`}
        onClick={() => onClick && onClick()}
      >
        {icon && <img src={icon} onError={(e) => { onErrorLoadAsset(); }} />}
      </Button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/components/LandingIconButton/index.jsx